import * as React from "react";
import {
	Apartment,
	Business,
	BusinessCenter,
	Co2,
	DeviceHub,
	Engineering,
	Factory,
	Flag,
	Inventory,
	Mediation,
	Person,
	PrecisionManufacturing,
	Restaurant,
	Room,
	Store,
	Storefront,
	Warehouse,
	Work,
} from "@mui/icons-material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AcUnitIcon from "@mui/icons-material/AcUnitRounded";
import Add from "@mui/icons-material/AddRounded";
import AirplanemodeActiveRoundedIcon from "@mui/icons-material/AirplanemodeActiveRounded";
import AirIcon from "@mui/icons-material/AirRounded";
import AltRouteRoundedIcon from "@mui/icons-material/AltRouteRounded";
import ApartmentRoundedIcon from "@mui/icons-material/ApartmentRounded";
import ArrowDow from "@mui/icons-material/ArrowDownward";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUpRounded";
import ArrowUp from "@mui/icons-material/ArrowUpwardRounded";
import Bookmark from "@mui/icons-material/BookmarkRounded";
import BookmarksRoundedIcon from "@mui/icons-material/BookmarksRounded";
import BusinessCenterRoundedIcon from "@mui/icons-material/BusinessCenterRounded";
import CategoryRoundedIcon from "@mui/icons-material/CategoryRounded";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreenRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import GroupFilter from "@mui/icons-material/ContentCopyRounded";
import DataObjectRoundedIcon from "@mui/icons-material/DataObjectRounded";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import DeviceHubOutlinedIcon from "@mui/icons-material/DeviceHubOutlined";
import DifferenceRoundedIcon from "@mui/icons-material/DifferenceRounded";
import DirectionsBoatFilledRoundedIcon from "@mui/icons-material/DirectionsBoatFilledRounded";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import ElectricBoltIcon from "@mui/icons-material/ElectricBoltRounded";
import ExpandMoreIcon from "@mui/icons-material/ExpandMoreRounded";
import FactoryRoundedIcon from "@mui/icons-material/FactoryRounded";
import FilterListOffIcon from "@mui/icons-material/FilterListOffRounded";
import FilterListIcon from "@mui/icons-material/FilterListRounded";
import NoData from "@mui/icons-material/FindInPageRounded";
import FolderCopyIcon from "@mui/icons-material/FolderCopy";
import HomeWorkRoundedIcon from "@mui/icons-material/HomeWorkRounded";
import ImageIcon from "@mui/icons-material/ImageRounded";
import Info from "@mui/icons-material/InfoRounded";
import InsightsRoundedIcon from "@mui/icons-material/InsightsRounded";
import Inventory2RoundedIcon from "@mui/icons-material/Inventory2Rounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import LinearScaleRoundedIcon from "@mui/icons-material/LinearScaleRounded";
import Link from "@mui/icons-material/LinkRounded";
import Truck from "@mui/icons-material/LocalShippingRounded";
import LocationOffRoundedIcon from "@mui/icons-material/LocationOffRounded";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import LoginRoundedIcon from "@mui/icons-material/LoginRounded";
import LoopIcon from "@mui/icons-material/LoopRounded";
import ManageSearchIcon from "@mui/icons-material/ManageSearchRounded";
import MediationRoundedIcon from "@mui/icons-material/MediationRounded";
import MoreHorizIcon from "@mui/icons-material/MoreHorizRounded";
import MoreHorizRoundedIcon from "@mui/icons-material/MoreHorizRounded";
import MoveDownRoundedIcon from "@mui/icons-material/MoveDownRounded";
import MoveUpRoundedIcon from "@mui/icons-material/MoveUpRounded";
import MyLocationRoundedIcon from "@mui/icons-material/MyLocationRounded";
import Navigate from "@mui/icons-material/NavigateNextRounded";
import NightlightRoundedIcon from "@mui/icons-material/NightlightRounded";
import OilBarrelIcon from "@mui/icons-material/OilBarrelRounded";
import OpenInFullIcon from "@mui/icons-material/OpenInFullRounded";
import PinDrop from "@mui/icons-material/PlaceRounded";
import PrecisionManufacturingRoundedIcon from "@mui/icons-material/PrecisionManufacturingRounded";
import PushPinOutlinedIcon from "@mui/icons-material/PushPinOutlined";
import PushPinIcon from "@mui/icons-material/PushPinRounded";
import QueryStatsRoundedIcon from "@mui/icons-material/QueryStatsRounded";
import QuizIcon from "@mui/icons-material/Quiz";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import RestaurantRoundedIcon from "@mui/icons-material/RestaurantRounded";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import SchemaRoundedIcon from "@mui/icons-material/SchemaRounded";
import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import Search from "@mui/icons-material/SearchRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import StoreRoundedIcon from "@mui/icons-material/StoreRounded";
import SwapHorizRoundedIcon from "@mui/icons-material/SwapHorizRounded";
import TableViewRoundedIcon from "@mui/icons-material/TableViewRounded";
import TrainRoundedIcon from "@mui/icons-material/TrainRounded";
import TransitEnterexitRoundedIcon from "@mui/icons-material/TransitEnterexitRounded";
import TravelExploreRoundedIcon from "@mui/icons-material/TravelExploreRounded";
import TrendingDownRoundedIcon from "@mui/icons-material/TrendingDownRounded";
import TrendingFlatRoundedIcon from "@mui/icons-material/TrendingFlatRounded";
import TrendingUpRoundedIcon from "@mui/icons-material/TrendingUpRounded";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import UploadRoundedIcon from "@mui/icons-material/UploadRounded";
import ViewCarouselRoundedIcon from "@mui/icons-material/ViewCarouselRounded";
import ViewColumnIcon from "@mui/icons-material/ViewColumnRounded";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOffRounded";
import VisibilityRoundedIcon from "@mui/icons-material/VisibilityRounded";
import WarehouseRoundedIcon from "@mui/icons-material/WarehouseRounded";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import Water from "@mui/icons-material/WaterRounded";
import WavesRoundedIcon from "@mui/icons-material/WavesRounded";
import WbSunnyRoundedIcon from "@mui/icons-material/WbSunnyRounded";
import WysiwygRoundedIcon from "@mui/icons-material/WysiwygRounded";
import { SxProps } from "@mui/material";

export interface IconProps {
	color?: "inherit" | "action" | "disabled" | "primary" | "secondary" | "error" | "info" | "success" | "warning";
	fontSize?: "inherit" | "small" | "medium" | "large";
	style?: SxProps;
	sx?: object;
}

const withProps =
	(Icon: React.ElementType) =>
	({ color = "primary", fontSize = "medium", style, ...props }: IconProps) => (
		<Icon color={color} fontSize={fontSize} style={style} {...props} />
	);

// Menu icons
export const HomeIcon = withProps(HomeWorkRoundedIcon);
export const Co2Icon = withProps(Co2);
export const InsightsIcon = withProps(InsightsRoundedIcon);
export const WhatIfIcon = withProps(AltRouteRoundedIcon);
export const DataIOIcon = withProps(SwapHorizRoundedIcon);
export const MasterDataIcon = withProps(DataObjectRoundedIcon);
export const KnowHowIcon = withProps(SchoolRoundedIcon);
export const SettingsIcon = withProps(SettingsRoundedIcon);
export const ThemeIcon = withProps(WbSunnyRoundedIcon);
export const LogOutIcon = withProps(LoginRoundedIcon);
export const DarkIcon = withProps(NightlightRoundedIcon);
export const AccountIcon = withProps(AccountCircleIcon);

// Filters menu icons
export const SavedFilters = withProps(BookmarksRoundedIcon);
export const OtherFilters = withProps(TuneRoundedIcon);
export const ConfigurationFilters = withProps(WysiwygRoundedIcon);
export const AddGroupIcon = withProps(FolderCopyIcon);
export const EditFilterIcon = withProps(MoreHorizRoundedIcon);

// Generic icons
export const NoDataIcon = withProps(NoData);
export const PinDropIcon = withProps(PinDrop);
export const NavigateIcon = withProps(Navigate);
export const FilterIcon = withProps(FilterListIcon);
export const FilterIconOff = withProps(FilterListOffIcon);
export const ArrowDonwIcon = withProps(KeyboardArrowDownRoundedIcon);
export const ArrowDropdown = withProps(ArrowDropDownRoundedIcon);
export const ArrowUpIcon = withProps(ArrowDropUpIcon);
export const OptionMenuIcon = withProps(MoreHorizIcon);
export const EditIcon = withProps(EditRoundedIcon);
export const DeleteIcon = withProps(DeleteForeverRoundedIcon);
export const BookmarkIcon = withProps(Bookmark);
export const AddIcon = withProps(Add);
export const GroupFilterIcon = withProps(GroupFilter);
export const SearchIcon = withProps(Search);
export const PinOutlineIcon = withProps(PushPinOutlinedIcon);
export const NoPinIcon = withProps(LocationOffRoundedIcon);
export const PinIcon = withProps(PushPinIcon);
export const InfoIcon = withProps(Info);
export const OpenFullscreen = withProps(OpenInFullIcon);
export const CloseFullscreen = withProps(CloseFullscreenIcon);
export const ExpandMore = withProps(ExpandMoreIcon);
export const LockIcon = withProps(LockRoundedIcon);
export const ManageSearch = withProps(ManageSearchIcon);
export const LinkIcon = withProps(Link);
export const UpIcon = withProps(ArrowUp);
export const DownIcon = withProps(ArrowDow);
export const ColumnIcon = withProps(ViewColumnIcon);
export const VisibilityOff = withProps(VisibilityOffIcon);
export const DownloadIcon = withProps(DownloadRoundedIcon);
export const ImgIcon = withProps(ImageIcon);
export const CsvIcon = withProps(TableViewRoundedIcon);
export const ReloadIcon = withProps(RefreshRoundedIcon);
export const ExportPageIcon = withProps(DescriptionRoundedIcon);
export const UpTrendIcon = withProps(TrendingUpRoundedIcon);
export const DownTrendIcon = withProps(TrendingDownRoundedIcon);
export const FlatTrendIcon = withProps(TrendingFlatRoundedIcon);
export const UploadIcon = withProps(UploadRoundedIcon);
export const CloseIcon = withProps(CloseRoundedIcon);
export const SearchAddressIcon = withProps(TravelExploreRoundedIcon);
export const SearchCordinatesIcon = withProps(MyLocationRoundedIcon);
export const SaveIcon = withProps(SaveRoundedIcon);
export const SchemaIcon = withProps(SchemaRoundedIcon);
export const LinkUnitIcon = withProps(ViewCarouselRoundedIcon);
export const CopyFromUpIcon = withProps(MoveDownRoundedIcon);
export const CopyFromDowIcon = withProps(MoveUpRoundedIcon);
export const LinkIconRoot = withProps(QueryStatsRoundedIcon);
export const WaringIcon = withProps(WarningAmberRoundedIcon);

// Transport type icons
export const ShipIcon = withProps(DirectionsBoatFilledRoundedIcon);
export const PlaneIcon = withProps(AirplanemodeActiveRoundedIcon);
export const TruckIcon = withProps(Truck);
export const TrainIcon = withProps(TrainRoundedIcon);
export const WaterWavesIcon = withProps(WavesRoundedIcon);
export const OtherIcon = withProps(QuizIcon);

// Node icons
export const FlagIcon = withProps(Flag);
export const FactoryWarehouseIcon = withProps(DeviceHub);
export const SuburbanWarehouseIcon = withProps(Apartment);
export const WarehouseIcon = withProps(Warehouse);
export const CopackerIcon = withProps(Mediation);
export const LocationIcon = withProps(Room);
export const StorefrontIcon = withProps(Storefront);
export const PersonIcon = withProps(Person);
export const BoxIcon = withProps(Inventory);
export const BusinessIcon = withProps(Business);
export const BusinessCenterIcon = withProps(BusinessCenter);
export const RestaurantIcon = withProps(Restaurant);
export const FactoryIcon = withProps(Factory);
export const WorkIcon = withProps(Work);
export const StoreIcon = withProps(Store);
export const PrecisionManufacturingIcon = withProps(PrecisionManufacturing);
export const EngineeringIcon = withProps(Engineering);
export const ViewPage = withProps(VisibilityRoundedIcon);

// Consumption by source icons
export const ElectricityIcon = withProps(ElectricBoltIcon);
export const FuelIcon = withProps(OilBarrelIcon);
export const FridgeIcon = withProps(AcUnitIcon);
export const ProcessGasIcon = withProps(LoopIcon);
export const HeatSteamIcon = withProps(AirIcon);
export const WaterIcon = withProps(Water);

// Node types icons
export const PlantWarehouseIcon = withProps(DeviceHubOutlinedIcon);
export const CentralWarehouseIcon = withProps(WarehouseRoundedIcon);
export const PeripheralWarehouseIcon = withProps(ApartmentRoundedIcon);
export const TransitPointIcon = withProps(TransitEnterexitRoundedIcon);
export const InterportRailwayNodeIcon = withProps(TrainRoundedIcon);
export const SeaportIcon = withProps(DirectionsBoatFilledRoundedIcon);
export const AirportIcon = withProps(AirplanemodeActiveRoundedIcon);
export const GDORetailDistributionCenterIcon = withProps(RestaurantRoundedIcon);
export const CustomerIcon = withProps(StoreRoundedIcon);
export const PlantIcon = withProps(FactoryRoundedIcon);
export const OfficeIcon = withProps(BusinessCenterRoundedIcon);
export const CommercialWarehouseIcon = withProps(CategoryRoundedIcon);
export const IndustrialWarehouseIcon = withProps(PrecisionManufacturingRoundedIcon);
export const IndustrialCopackerIcon = withProps(MediationRoundedIcon);
export const RawMaterialPackagingIcon = withProps(Inventory2RoundedIcon);

// RootCause icons
export const ComparisonIcon = withProps(AltRouteRoundedIcon);
export const BaselineIcon = withProps(LinearScaleRoundedIcon);
export const DeltaIcon = withProps(DifferenceRoundedIcon);
